import React from 'react'
import navigationIcon from 'configs/navigation-icon.config'
import { MenuItem } from 'components/ui'
import HorizontalMenuNavLink from './HorizontalMenuNavLink'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import useMenuActive from 'utils/hooks/useMenuActive'
import NavigationConfig from 'configs/navigation.config'

const HorizontalMenuItem = ({ nav, isLink, manuVariant, navMainMenu }) => {
    const { title, translateKey, icon, path } = nav

    const { t } = useTranslation()

    const itemTitle = t(translateKey, title)
    const currentRouteKey = useSelector(
        (state) => state.base.common.currentRouteKey
    )
    const navigationConfig = NavigationConfig()

    const { activedRoute, includedRouteTree } = useMenuActive(
        navigationConfig,
        currentRouteKey
    )

    return (
        <MenuItem
            variant={manuVariant}
            key={nav.key}
            eventKey={nav.key}
            isActive={activedRoute?.key === nav.key}
            className={
                activedRoute?.key === nav.key
                    ? 'border-y-4 rounded-none  py-7 border-b-red-500 border-t-transparent'
                    : 'py-7 border-y-4 rounded-none border-y-transparent'
            }
            navMainMenu={navMainMenu}
        >
            {icon && <span className="text-2xl">{navigationIcon[icon]}</span>}
            {path && isLink ? (
                <HorizontalMenuNavLink
                    path={path}
                    isActive={activedRoute?.key === nav.key}
                    target={nav?.target || '_self'}
                >
                    {itemTitle}
                </HorizontalMenuNavLink>
            ) : (
                <span>{itemTitle}</span>
            )}
        </MenuItem>
    )
}

export default HorizontalMenuItem
